import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import RetailerHeader from "./RetailerHeader";
import RetailerSideMenu from "./RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { Link } from "react-router-dom";
import moment from "moment";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class ViewRetailerOffers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          {
            label: "Offer Name ",
            field: "offer_name",
            sort: "asc",
            width: 150,
          },
          // {
          //   label: "Module",
          //   field: "module",
          //   sort: "asc",
          //   width: 150,
          // },

          // ...existing columns...
{
  label: "Offer Type",
  field: "offer_type",
  sort: "asc",
  width: 120,
},
{
  label: "Discount Value",
  field: "discount_value",
  sort: "asc",
  width: 120,
},
{
  label: "Applicable To",
  field: "applicable_to",
  sort: "asc",
  width: 120,
},
{
  label: "Categories",
  field: "categories",
  sort: "asc",
  width: 180,
},
{
  label: "Products",
  field: "products",
  sort: "asc",
  width: 180,
},
// ...existing columns...
          {
            label: "Start Date",
            field: "start_date",
            sort: "asc",
            width: 150,
          },
          {
            label: "End Date",
            field: "end_date",
            sort: "asc",
            width: 150,
          },
          // {
          //   label: "Discount Type",
          //   field: "is_percentage",
          //   sort: "asc",
          //   width: 150,
          // },
          // {
          //   label: "Discount % / Flat",
          //   field: "discount",
          //   sort: "asc",
          //   width: 150,
          // },
          {
            label: "Images",
            field: "images",
            sort: "asc",
            width: 180,
          },
          // {
          //   label: "Minimum Value",
          //   field: "minimumorder_value",
          //   sort: "asc",
          //   width: 150,
          // },
          // {
          //   label: "Maximum Discount Amount",
          //   field: "maximumdiscount_amount",
          //   sort: "asc",
          //   width: 150,
          // },
          // {
          //   label: "No Of Users",
          //   field: "numberof_user",
          //   sort: "asc",
          //   width: 150,
          // },
          // {
          //   label: "No Of Times",
          //   field: "numberof_times",
          //   sort: "asc",
          //   width: 150,
          // },
          {
            label: "Actions",
            field: "actions",
            sort: "asc",
            width: 250,
          },
          {
            label: "Status",
            field: "status",
            sort: "asc",
            width: 250,
          },


        ],
        rows: [],
      },

    };
    this.deleteOffer = this.deleteOffer.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    let userData = ls.get("retuserObj");

    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/retailer/login";
    }
    this.fetchpagesdata(userData.retailer_id);
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //update status for offer
  updateStatus(id, status) {
    // Use ActiveInactive API for status toggle (numeric: 1=active, 0=inactive)
    const newStatus = status === 1 ? 0 : 1;
    Httpconfig.httptokenput(
      `${Constant.siteurl}api/productsoffers/ActiveInactive/${newStatus}/${id}`
    )
      .then((response) => {
        toast.success("Successfully updated Status");
        setTimeout(() => this.fetchpagesdata(this.state.retailerId), 1000); // Refresh table
      })
      .catch((error) => toast.error("Failed to update status"));
  }

  fetchpagesdata(entity_id) {
    Httpconfig.httptokenpost(
      Constant.siteurl+ "api/productsoffers/getofferslist",
      {
        entity_id: entity_id,
        page: 1,
        limit: 10
      }
    )
      .then((response) => {
        // Defensive: check for array
        console.log("response", response.data.data);
        this.setState({
          page_data: response.data.data,
            
        });
        const offers = Array.isArray(response.data.data) ? response.data.data : [];

        let assignvalues = [];
  
        offers.forEach((item) => {
          // Parse images from stringified JSON
          let imagesArr = [];
          if (item.offer_images) {
            try {
              imagesArr = JSON.parse(item.offer_images);
            } catch (e) {
              imagesArr = [];
            }
          }
        
          assignvalues.push({
            offer_name: item.offer_name || '--',
            offer_type: item.offer_type || '--',
            discount_value: item.rule_details?.discount || '--',
            start_date: item.start_date ? moment(item.start_date).format("DD-MM-YYYY") : '--',
            end_date: item.end_date ? moment(item.end_date).format("DD-MM-YYYY") : '--',
            applicable_to: item.applicable_to || '--',
            description: item.description || '--',
            categories: (item.offer_mappings || [])
              .filter(m => m.category && m.category.category_name)
              .map(m => m.category.category_name)
              .join(", ") || '--',
              products: (item.offer_mappings.length || []),
              // .filter(m => m.product && m.product.medicinename)
              // .map(m => m.product.medicinename)
              // .join(", ") || '--',
            // products: (item.offer_mappings || [])
            //   .filter(m => m.product && m.product.medicinename)
            //   .map(m => m.product.medicinename)
            //   .join(", ") || '--',
            images: (
              <div style={{ display: "flex", gap: "4px" }}>
                {imagesArr.length }
                {/* {imagesArr.length > 0 ? imagesArr.map((img, idx) => (
                  <img
                    key={idx}
                    src={img.url}
                    alt="Offer"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" }}
                  />
                )) : '--'} */}
              </div>
            ),
            status: item.status == 1 ? (
              <MDBBadge
                color="success"
                onClick={() => this.updateStatus(item.id, item.status)}
              >
                <h5>Active</h5>
              </MDBBadge>
            ) : (
              <MDBBadge
                color="warning"
                onClick={() => this.updateStatus(item.id, item.status)}
              >
                <h5>Inactive</h5>
              </MDBBadge>
            ),
            actions: (
              <div>
                <span>
                  <Link
                    to={"/retailer/RetailerOffers/" + item.id}
                    className="fa fa-edit point-cursor"
                    title={"Update " + item.offer_name}
                  />
                </span>{" "}
                &nbsp;
                <span>
                  <i
                    onClick={() => this.deleteOffer(item.id, item.offer_name)}
                    className="fa fa-trash point-cursor"
                    title={"Delete " + item.offer_name}
                  />
                </span>{" "}
                &nbsp;
              </div>
            ),
          });
        });
        this.setState(prevState => ({
          ...prevState,
          datatable: {
            ...prevState.datatable,
            rows: assignvalues
          }
        }));
        // let couponState = Object.assign({}, this.state);
        console.log("assignvalues", assignvalues);
        this.datatable.rows = assignvalues;

      })
      .catch((error) => {
        console.error("Error fetching offers:", error);
       });
  }

  //delete controller
deleteOffer(offerId, offerName) {
  var isConfirm = window.confirm("Are you sure to delete " + offerName + "?");
  if (isConfirm) {
    Httpconfig.httptokendelete(Constant.siteurl + "api/productsoffers/" + offerId)
      .then((response) => {
        toast.success("Successfully Deleted offer");
        setTimeout(() => this.fetchpagesdata(this.state.retailerId), 1000); // Refresh table
      })
      .catch((error) => {
        toast.error("Failed to delete offer");
      });
  }
}
  render() {
    const { datatable } = this.state;
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div className="Pharma_Content">
            <div className="container-fluid">
              <div className="create-coupon-page">
                <div className="row ">
                  <div className="col-md-12">
                    <form>
                      <div className="tab-header create-coupon-header">
                        <h3> Offers</h3>
                        <Link
                          to="/retailer/RetailerOffers"
                          className="btn  btn-primary fright"
                        >
                          Create Offers
                        </Link> 
                        </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div id="" class="viewcoupons">                          
                    {datatable.rows.length === 0 ? (
                      console.log("No offers found")  ||
                      <p>No offers found</p>
                    ) : (
                      <MDBDataTable
                        responsive
                        striped
                        bordered
                        small
                        data={datatable}
                      />
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="update_btn"
                          style={{ textAlign: "right" }}
                        ></div>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>
          </div>                 
        </section>
      </main>
    );
  }
}
